A **Postgres restart will be required** to enable the `auto_explain` functionality.
If a restart is not acceptable for this server right now, you can instead try our alternate
[log-based EXPLAIN mechanism](../log_explain/01_create_helper_functions). You can switch to the `auto_explain` mechanism
at any time in the future by turning off the `enable_log_explain` collector setting and
following the `auto_explain` setup instructions here.